import React, { useEffect, useRef } from 'react';
import { getCanvaBarChart } from '../../../../services/chart/barChart';
import { formatDataForQuizSummaryChart } from '../../../../helpers/quiz/formatDataForQuizSummaryChart';
import {
  QuizWithCompetenceAndQuestions,
  UserWithQuizToNoteDef
} from '../../../../types/quiz/quiz.def';

interface BarChartProps {
  users: UserWithQuizToNoteDef[];
  quiz: QuizWithCompetenceAndQuestions;
  quizId: string;
}

export const BarChart = ({ users, quiz, quizId }: BarChartProps) => {
  const ref = useRef(null);
  const questions = quiz?.questions.map(q => q);
  const chartData = formatDataForQuizSummaryChart(users, quizId, questions);

  useEffect(() => {
    const chart = getCanvaBarChart(chartData, ref.current.getContext('2d'));
    return () => chart.destroy();
  }, [users, quizId, chartData]);

  return (
    <div style={{ height: '600px' }}>
      <canvas ref={ref} />
    </div>
  );
};
